import { AppUtil, EventEmitter, EnvUtil, BrowserUtil } from 'kuaidong-lib'

const eventEmitter = new EventEmitter()

export enum TitleBarActionEnum {
  Share = 'share',
  About = 'about',
}

export class TitleBar {
  static hidedAppBar = false
  static defaultTitle = EnvUtil.appNameZHCN()
  static pathConfig = {
    hideBack: false,
    title: '',
    path: '',
    backLevel: -1,
    eventEmitter: eventEmitter,
  }

  public static async init() {
    const isUnderApp = await AppUtil.isUnderApp()

    if (isUnderApp || BrowserUtil.isWeapp()) {
      if (isUnderApp) {
        await AppUtil.hideAppTitleBar()
      }

      this.hidedAppBar = true

      return this.hidedAppBar
    } else {
      return false
    }
  }

  public static setTitle(title: string) {
    this.pathConfig.title = title
  }

  public static getTitle() {
    return this.pathConfig.title ? this.pathConfig.title : this.defaultTitle
  }

  public static delayDisableBack() {
    setTimeout(() => {
      TitleBar.disableBack()
    }, 50)
  }

  public static disableBack() {
    this.clearBackPath()
    this.pathConfig.hideBack = true
  }

  public static clearBackPath() {
    this.pathConfig.hideBack = false
    this.pathConfig.path = ''
    this.pathConfig.title = ''
    this.pathConfig.backLevel = -1
  }

  public static setBackPath(path: string) {
    this.pathConfig.path = path
    this.pathConfig.path = path
  }

  public static setBackLevel(level: number) {
    this.pathConfig.backLevel = level
  }

  public static on(action: TitleBarActionEnum, handler: Function) {
    this.pathConfig.eventEmitter.on(action, handler)
  }

  public static fire(action: TitleBarActionEnum) {
    this.pathConfig.eventEmitter.fire(action)
  }

  public static removeAllActions() {
    this.pathConfig.eventEmitter.removeAllListeners()
  }
}
